import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-candidate-saved-jobs',
  templateUrl: './dashboard-saved-jobs.component.html',
  styleUrls: ['./dashboard-saved-jobs.component.scss']
})
export class DashboardCandidateSavedJobsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
